export const LOGOUT_TYPE = {
  LogoutClearAll: '1',
  LogoutClearPart: '2',
};
